import React from "react";
import {
  Box,
  Card,
  CardContent,
  InputAdornment,
  Stack,
  TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { tokens } from "../../theme";

export interface DataListCardProps {
  children: React.ReactNode;
  searchPlaceholder?: string;
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  filters?: React.ReactNode;
  toolbarActions?: React.ReactNode;
  footer?: React.ReactNode;
}

const DataListCard: React.FC<DataListCardProps> = ({
  children,
  searchPlaceholder = "Search…",
  searchValue,
  onSearchChange,
  filters,
  toolbarActions,
  footer,
}) => (
  <Card
    sx={{
      borderRadius: tokens.radius.md,
      border: "1px solid",
      borderColor: "divider",
      boxShadow: "none",
      overflow: "hidden",
    }}
  >
    {(onSearchChange || filters || toolbarActions) && (
      <Box
        sx={{
          px: 1.25,
          py: 1,
          borderBottom: "1px solid",
          borderColor: "divider",
          bgcolor: "background.paper",
        }}
      >
        <Stack
          direction={{ xs: "column", lg: "row" }}
          spacing={1}
          alignItems={{ xs: "stretch", lg: "center" }}
          justifyContent="space-between"
        >
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1} flex={1}>
            {onSearchChange && (
              <TextField
                size="small"
                placeholder={searchPlaceholder}
                value={searchValue ?? ""}
                onChange={(e) => onSearchChange(e.target.value)}
                sx={{ minWidth: { sm: 200 }, maxWidth: 280 }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ fontSize: 16 }} color="action" />
                    </InputAdornment>
                  ),
                }}
              />
            )}
            {filters}
          </Stack>
          {toolbarActions && (
            <Stack direction="row" spacing={0.75} alignItems="center" flexWrap="wrap" useFlexGap>
              {toolbarActions}
            </Stack>
          )}
        </Stack>
      </Box>
    )}
    <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>{children}</CardContent>
    {footer && (
      <Box
        sx={{
          borderTop: "1px solid",
          borderColor: "divider",
          bgcolor: "background.paper",
        }}
      >
        {footer}
      </Box>
    )}
  </Card>
);

export default DataListCard;
